import Helper from '@ember/component/helper';

import { addObserver } from '@ember/object/observers';
import { service } from '@ember/service';

export default class TimeSeriesSelectLinkHelper extends Helper {
  @service('route/time-series') timeSeriesRoute;

  init() {
    super.init(...arguments);
    addObserver(this, 'timeSeriesRoute.getLinkToSelect', this, 'recompute');
  }

  compute(params, {
    clearDates,
    clearDefaultDates,
    clearItemDates,
    clearModelRunDates,
    setDefaultDates,
    setItemDates,
    setModelRunDates,
    clearLocations,
    copyDefaultDates,
    addLocation,
    addItem,
    addModelRun,
    toggleLocation,
    toggleItem,
    toggleModelRun,
    route,
    queryParams,
  }) {
    return this.timeSeriesRoute.getLinkToSelect({
      clearDates,
      clearDefaultDates,
      clearItemDates,
      clearModelRunDates,
      setDefaultDates,
      setItemDates,
      setModelRunDates,
      clearLocations,
      copyDefaultDates,
      addLocation,
      addItem,
      addModelRun,
      toggleLocation,
      toggleItem,
      toggleModelRun,
      route,
      queryParams,
    });
  }
}
